<template>
<transition name="lab" appear>
  <div id="lab" :key="$route.name">
    <div class="lab__container">
      <a :href="item.url" v-for="item in data" :key="item.id" class="lab__item" target="_blank">
        <p>{{item.date}}</p>
        <h4>{{item.title}}</h4>
        <ul>
          <li v-for="tag in item.tags" :key="tag.id" class="lab__tag">{{tag}}</li>
        </ul>
      </a>
    </div>
  </div>
</transition>
</template>

<script>

import data from '@/json/lab'

export default {
  name: 'Lab',
  data(){
    return{
      data
    }
  },
  mounted() {
    this.$store.commit('setShow', false);
  },
}
</script>

<style lang="scss">
#lab{
  background: var(--black);
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 120;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .lab__container{
    width: 100% ;//calc((100% / 4) * 3);
    height: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    border-top: 1px solid rgba(148, 148, 148, 0.295);;
    border-bottom: 1px solid rgba(148, 148, 148, 0.295);;
    margin-left: calc(5.5vw - 6px);
    .lab__item{
      width: calc(100vw / 4);
      height: 250px;
      padding: 40px;
      color: var(--white);
      font-size: 1.8rem;
      font-family: var(--conduitITC);
      font-weight: 400;
      display: flex;
      flex-direction: column;
      text-decoration: none;
      margin-bottom: -1px;
      &:nth-child(1) {
        border-bottom: 1px solid rgba(148, 148, 148, 0.295);
      }
      &:nth-child(2) {
        border-bottom: 1px solid rgba(148, 148, 148, 0.295);
      }
      &:nth-child(3) {
        border-bottom: 1px solid rgba(148, 148, 148, 0.295);
      }
      
      &:nth-child(3n) {
        margin-right: calc(100vw / 4);
      }
      &:nth-child(3n + 1) {
        width: calc(100vw / 4 - (5.5vw - 6px));
      }
      p{
        color: var(--primary);
        font-size: 1.2rem;
        opacity: .8;
      }
      h4{
        color: var(--white);
        font-size: 1.8rem;
        font-family: var(--editor);
        font-weight: 400;
        margin-top: 12px;   
      }
      ul{
        margin-top: auto;
        display: flex;
        flex-direction: row;
        list-style: none;
        font-size: 1.4rem;
        li{
          margin-right: 15px;
          color: var(--grey);
          text-transform: uppercase;
        }
      }
    }
  }
  .line{
    background: #242424;
  }
}


.lab-enter-active, .lab-leave-active{
  transition: transform .35s var(--easing), opacity .2s var(--easing);
  transform-style: preserve-3d;
}
.lab-enter, .lab-leave-to{
  transform: translateZ(200px) rotateZ(25deg) rotateX(-20deg);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Lab.vue